/*
 *  -----------------------------------------------------------------------
 *    <copyright file="visit-tab/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React, { useEffect, useState } from 'react';
import VisitsTabGrid from '@components/admin/visits-tab/visit-tab-grid/visit-tab-grid';
import { VisitsTabProps } from '@components/admin/visits-tab/visits-tab.interface';
import EditMultipleFieldsModal from '@components/core/edit-multiple-fields-modal';
import { useBoolean, useLocalState } from 'hooks';
import { StudyVisitScheduleFields } from 'queries/generated/fragments.generated';

import './styles.scss';

const VisitsTab = ({
    currentSchedule,
    visits,
    currentVisit,
    setCurrentVisit,
    canEdit,
    showNewVisit,
    switchMenu,
    showEditSequenceWarning,
    assignedItem,
    disableTools,
}: VisitsTabProps) => {
    const { state: localState } = useLocalState();
    const study = localState.selectedStudy;
    const studyId = study?.id;
    const currentScheduleId = currentSchedule?.id;

    const openEditVisits = useBoolean(false);
    const [selectedVisits, setSelectedVisits] = useState<StudyVisitScheduleFields[]>([]);

    useEffect(() => {
        if (!visits?.length) {
            // back to Add Visits if no visits in grid
            showNewVisit.setTrue();
            setCurrentVisit(null);
        }
    }, [visits]);

    const openEditMultipleVisits = (visitsToEdit: StudyVisitScheduleFields[]) => {
        setSelectedVisits(visitsToEdit);
        openEditVisits.setTrue();
    };

    return (
        <div className="svt-grid-container">
            <EditMultipleFieldsModal
                modalType="visits"
                open={openEditVisits.value}
                onClose={() => {
                    openEditVisits.setFalse();
                }}
                study={study}
                visits={visits}
                itemsToUpdateArray={selectedVisits}
                currentScheduleId={currentScheduleId}
            />
            <VisitsTabGrid
                currentScheduleId={currentSchedule?.id}
                currentScheduleVersion={currentSchedule?.version}
                canEdit={canEdit}
                visits={visits}
                studyId={studyId}
                study={study}
                currentVisit={currentVisit}
                setCurrentVisit={setCurrentVisit}
                showNewVisit={showNewVisit}
                switchMenu={switchMenu}
                showBulkEditDialog={openEditMultipleVisits}
                showEditSequenceWarning={showEditSequenceWarning}
                assignedItem={assignedItem}
                disableTools={disableTools}
            />
        </div>
    );
};

export default VisitsTab;
